import { appApiSlice } from 'src/api/app-ApiSlice';
import {
    DeleteFloorResponse,
    GetFloorRoomsAndRelatedObjectsResponse,
    GetFloorsRequest,
    GetFloorsResponse,
    GetProductsOfRoomsByFloorsResponse,
    UpsertFloorRequest,
    UpsertFloorResponse
} from 'src/model/api/v2/data-contracts';
import {
    TAG_FLOOR_ROOMS_AND_RELATED,
    TAG_FLOOR_VIEW_PRODUCTS,
    TAG_GET_DEVICES,
    TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS,
    TAG_GET_QUOTE,
    TAG_PINOUT_DEVICES,
    TAG_PROJECT_QUOTE_DATA,
    TAG_PROJECT_TREE
} from 'src/api/api-tags';

export const floorV2ApiSlice = appApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProductsOfRoomsByFloors: builder.query<GetProductsOfRoomsByFloorsResponse, number>({
            query: (project_id: number) => `v2/floor/get-products-of-rooms-by-floors?project_id=${project_id}`,
            providesTags: [
                { type: TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS },
                { type: TAG_FLOOR_VIEW_PRODUCTS },
            ],
        }),
        createFloor: builder.mutation<UpsertFloorResponse, UpsertFloorRequest>({
            query: (floorData: any) => {
                const formData = new FormData();
                if (floorData.floorId) formData.append('floorId', floorData.floorId.toString());
                formData.append('projectId', floorData.projectId.toString());
                formData.append('floorName', floorData.floorName);
                formData.append('headroom', floorData.headroom);
                formData.append('lengthProportion', floorData.lengthProportion);
                if (floorData.planImage) formData.append('planImage', floorData.planImage);

                return {
                    url: 'v2/floor/upsert-floor',
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: [
                { type: TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS },
                { type: TAG_FLOOR_ROOMS_AND_RELATED },
                { type: TAG_PROJECT_TREE },
                { type: TAG_PROJECT_QUOTE_DATA },
                { type: TAG_GET_QUOTE },
                { type: TAG_PINOUT_DEVICES },
                { type: TAG_GET_DEVICES }
            ],
        }),
        deleteFloor: builder.mutation<DeleteFloorResponse, number>({
            query: (floorId ) => ({
                url: `v2/floor?floorId=${floorId}`,
                method: 'DELETE',
            }),
            invalidatesTags: [
                { type: TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS },
                { type: TAG_FLOOR_ROOMS_AND_RELATED },
                { type: TAG_PROJECT_TREE },
                { type: TAG_PROJECT_QUOTE_DATA },
                { type: TAG_GET_QUOTE },
                { type: TAG_PINOUT_DEVICES },
                { type: TAG_GET_DEVICES }
            ],
        }),
        getFloors: builder.query<GetFloorsResponse, GetFloorsRequest>({
            query: ({ project_id }) => `v2/floor/get-floors?project_id=${project_id}`,
            providesTags: [{ type: TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS }],
        }),
        getFloorRoomsAndRelatedObjects: builder.query<GetFloorRoomsAndRelatedObjectsResponse, number>({
          query: (floorId) => `v2/floor/get-floor-rooms-and-related-objects?floorId=${floorId}`,
          providesTags: (result, error, floorId) => [{ type: TAG_FLOOR_ROOMS_AND_RELATED, id: floorId }],
        })
    }),
    overrideExisting: false
});

export const {
    useGetProductsOfRoomsByFloorsQuery,
    useCreateFloorMutation,
    useDeleteFloorMutation,
    useGetFloorsQuery,
    useGetFloorRoomsAndRelatedObjectsQuery
} = floorV2ApiSlice;
